import type { ReactNode } from "react"
import { Trans } from "@lingui/react/macro"

// Desktop footer bar for the command palette (CON-183).
//
// Left: keyboard hints (↵ Open, ↑↓ Navigate). Right: a muted
// "Search across your workspace" caption. Mobile drops the
// footer entirely (the bottom is reserved for results +
// safe-area), so this only renders in the desktop modal.

export function PaletteFooter() {
  return (
    <div className="flex items-center justify-between border-t border-[#F0EDE6] px-4 py-2.5">
      <div className="flex items-center gap-4">
        <FooterHint keyLabel="↵" text={<Trans>Open</Trans>} />
        <FooterHint keyLabel="↑↓" text={<Trans>Navigate</Trans>} />
      </div>
      <span className="text-[11px] leading-3.5 text-[#9A938A]">
        <Trans>Search across your workspace</Trans>
      </span>
    </div>
  )
}

function FooterHint({ keyLabel, text }: { keyLabel: string; text: ReactNode }) {
  return (
    <span className="flex items-center gap-1.5">
      <kbd className="flex min-w-[18px] items-center justify-center rounded border border-[#E5DFD3] bg-[#FAF7F1] px-1 py-0.5 text-[10px] leading-3 font-medium text-[#7A746B]">
        {keyLabel}
      </kbd>
      <span className="text-[11px] leading-3.5 text-[#7A746B]">{text}</span>
    </span>
  )
}
